import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var firebaseConfig = {
  apiKey: "AIzaSyBSWaLoex4nwvEdnMcVV87QKRmVAdW9lEw",
  authDomain: "zoom-back.firebaseapp.com",
  databaseURL: "https://zoom-back.firebaseio.com",
  projectId: "zoom-back",
  storageBucket: "zoom-back.appspot.com",
  messagingSenderId: "718340887444",
  appId: "1:718340887444:web:9dd2424c65f0d62ad6f581",
  measurementId: "G-ZPGN3T0DLQ"
};
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  export default firebase;